<button
    [attr.id]="id ? (id + '_button') : null"
    class="agpr-button"
    (click)="onClick($event)"
    (keydown)="onKeydown($event)"
    (keyup)="onKeyup($event)"
    [attr.tabindex]="tabindex ? tabindex : null"
    [agprTooltip]="tooltip | localize"
    [useTooltipAsAriaLabel]="!ariaLabel"
    [tooltipPosition]="tooltipPosition"
    [initiallyFocusable]="initiallyFocusable"
    [forceTooltipOnFocus]="forceTooltipOnFocus"
    [tooltipStyleClass]="tooltipStyleClass"
    [attr.aria-label]="ariaLabel | localize"
    [attr.aria-expanded]="expanded"
    [attr.aria-describedby]="ariaDescribedBy"
    [attr.aria-haspopup]="ariaHasPopup"
    [attr.aria-disabled]="disabled || loading"
    [attr.aria-controls]="ariaControls"
    [attr.role]="role"
    [attr.aria-selected]="ariaSelected"
    [ngClass]="{
        'agpr-button--loading': loading,
        'agpr-button--wide': wide,
        'agpr-button--disabled': disabled,
        'agpr-button--primary': style === buttonTypes.primary,
        'agpr-button--primaryB': style === buttonTypes.primaryB,
        'agpr-button--secondary': style === buttonTypes.secondary,
        'agpr-button--tertiary': style === buttonTypes.tertiary,
        'agpr-button--link': style === buttonTypes.link,
        'agpr-button--textToggle': style === buttonTypes.textToggle,
        'agpr-button--big': style === buttonTypes.big,
        'agpr-button--block': style === buttonTypes.block,
        'agpr-button--icon': style === buttonTypes.icon || style === buttonTypes.colorSwatch,
        'agpr-button--iconFilled': style === buttonTypes.iconFilled,
        'agpr-button--contextMenu': style === buttonTypes.contextMenu,
        'agpr-button--image': style === buttonTypes.image,
        'agpr-button--colorSwatch': style === buttonTypes.colorSwatch,
        'agpr-button--active': active
    }"
    type="button"
>
    @if (icon) {
        <span
            [attr.id]="id ? (id + '_button_icon') : null"
            class="agpr-button-icon"
            [ngClass]="icon"
            aria-hidden="true"
        ></span>
    }

    @if (style === buttonTypes.image) {
        <img
            [attr.id]="id ? (id + '_button_image') : null"
            class="agpr-button-image"
            [ngClass]="imageClass"
            [agprImageSrc]="imageUrl"
            [agprDefaultImage]="imageUrlDefault"
            [alt]="hideImageAlt ? '' : tooltip"
        />
    }

    @if (label) {
        <span
            [attr.id]="id ? (id + '_button_label') : null"
            class="agpr-button-label"
            [ngClass]="{'agpr-button-label-underline': underline}"
        >
            {{ label | localize }}
        </span>
    }

    <ng-content></ng-content>

    @if (tailIcon) {
        <span
            [attr.id]="id ? (id + '_button_tailIcon') : null"
            class="agpr-button-icon"
            [ngClass]="tailIcon"
            aria-hidden="true"
        ></span>
    }

    @if (loading !== null && loading !== undefined) {
        <span
            [attr.id]="id ? (id + '_button_loading') : null"
            class="loadingIndicator-area"
            [agprLoading]="loading"
            [agprInlineLoadingIndicator]="true"
            [loadingSmallIndicator]="true"
            [loadingLightMode]="loadingIndicatorLightMode || style === buttonTypes.primary"
        ></span>
    }
</button>
